import CheckIcon from '../assets/svg/CheckIcon';
import CrossIcon from '../assets/svg/CrossIcon';

export const REPORT_STATUS_MAP = {
  PERFORMED: 'Performed',
  SCHEDULED: 'Scheduled',
  DECLINED: 'Declined',
  NO_SHOW: 'No Show',
  REJECTED: 'Rejected',
};

export const STATUS_BG_COLOR_MAP = {
  [REPORT_STATUS_MAP.PERFORMED]: 'bg-success-500/15',
  [REPORT_STATUS_MAP.SCHEDULED]: 'bg-brand-300/15',
  [REPORT_STATUS_MAP.DECLINED]: 'bg-declined-500/15',
  [REPORT_STATUS_MAP.NO_SHOW]: 'bg-destructive-500/15',
  [REPORT_STATUS_MAP.REJECTED]: 'bg-rejected-500/15',
};

export const STATUSES = [
  {
    label: 'Performed',
    value: REPORT_STATUS_MAP.PERFORMED,
    color: 'bg-success-500',
  },
  {
    label: 'Scheduled',
    value: REPORT_STATUS_MAP.SCHEDULED,
    color: 'bg-brand-300',
  },
  {
    label: 'Declined',
    value: REPORT_STATUS_MAP.DECLINED,
    color: 'bg-declined-500',
  },
  {
    label: 'No Show',
    value: REPORT_STATUS_MAP.NO_SHOW,
    color: 'bg-destructive-500',
  },
  {
    label: 'Rejected',
    value: REPORT_STATUS_MAP.REJECTED,
    color: 'bg-rejected-500',
  },
];

export const APPT_TYPES = ['Discovery Call', 'Demo'];

export const AVAILABLE_REPORT_STATUSES_BY_REPORT_STATUS = {
  [REPORT_STATUS_MAP.SCHEDULED]: [
    {
      value: REPORT_STATUS_MAP.PERFORMED,
      label: 'Performed',
      icon: <CheckIcon className="w-4 h-4 text-success-500" />,
    },
    {
      value: REPORT_STATUS_MAP.DECLINED,
      label: 'Declined',
      icon: <CrossIcon className="w-4 h-4 text-declined-500" />,
    },
    {
      value: REPORT_STATUS_MAP.NO_SHOW,
      label: 'No Show',
      icon: <CrossIcon className="w-4 h-4 text-destructive-500" />,
    },
    {
      value: REPORT_STATUS_MAP.REJECTED,
      label: 'Rejected',
      icon: <CrossIcon className="w-4 h-4 text-rejected-500" />,
    },
  ],
  [REPORT_STATUS_MAP.PERFORMED]: [
    {
      value: REPORT_STATUS_MAP.DECLINED,
      label: 'Declined',
      icon: <CrossIcon className="w-4 h-4 text-declined-500" />,
    },
    {
      value: REPORT_STATUS_MAP.NO_SHOW,
      label: 'No Show',
      icon: <CrossIcon className="w-4 h-4 text-destructive-500" />,
    },
    {
      value: REPORT_STATUS_MAP.REJECTED,
      label: 'Rejected',
      icon: <CrossIcon className="w-4 h-4 text-rejected-500" />,
    },
  ],
  [REPORT_STATUS_MAP.DECLINED]: [
    {
      value: REPORT_STATUS_MAP.PERFORMED,
      label: 'Performed',
      icon: <CheckIcon className="w-4 h-4 text-success-500" />,
    },
    {
      value: REPORT_STATUS_MAP.NO_SHOW,
      label: 'No Show',
      icon: <CrossIcon className="w-4 h-4 text-destructive-500" />,
    },
    {
      value: REPORT_STATUS_MAP.REJECTED,
      label: 'Rejected',
      icon: <CrossIcon className="w-4 h-4 text-rejected-500" />,
    },
  ],
  [REPORT_STATUS_MAP.REJECTED]: [
    {
      value: REPORT_STATUS_MAP.PERFORMED,
      label: 'Performed',
      icon: <CheckIcon className="w-4 h-4 text-success-500" />,
    },
    {
      value: REPORT_STATUS_MAP.DECLINED,
      label: 'Declined',
      icon: <CrossIcon className="w-4 h-4 text-declined-500" />,
    },
    {
      value: REPORT_STATUS_MAP.NO_SHOW,
      label: 'No Show',
      icon: <CrossIcon className="w-4 h-4 text-destructive-500" />,
    },
  ],
  [REPORT_STATUS_MAP.NO_SHOW]: [
    {
      value: REPORT_STATUS_MAP.PERFORMED,
      label: 'Performed',
      icon: <CheckIcon className="w-4 h-4 text-success-500" />,
    },
    {
      value: REPORT_STATUS_MAP.DECLINED,
      label: 'Declined',
      icon: <CrossIcon className="w-4 h-4 text-declined-500" />,
    },
    {
      value: REPORT_STATUS_MAP.REJECTED,
      label: 'Rejected',
      icon: <CrossIcon className="w-4 h-4 text-rejected-500" />,
    },
  ],
};

export const REPORT_FILE_FORMAT = {
  CSV: 'csv',
  XLSX: 'xlsx',
};

export const REPORT_FORMAT_OPTIONS = [
  { value: REPORT_FILE_FORMAT.CSV, label: 'CSV' },
  { value: REPORT_FILE_FORMAT.XLSX, label: 'XLSX' },
];
